module.exports = __webpack_public_path__ + "img/trial1-3.0e9810a0.png";